module.exports = __webpack_public_path__ + "static/media/policy_icon.1fdb7483.svg";